import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ListToolBarActions from 'components/toolbar/ListToolBarActions';
import EToolTip from 'components/others/EToolTip';
import SolarIcon from 'components/icons/SolarIcon';
import type { StockControlColumnId } from './model/useStockControlPage';

interface StockControlToolBarProps {
    filterActive: boolean;
    onShowFilter: () => void;
    onReset: () => void;
    onRefresh: () => void;
    showCategory: boolean;
    showArticle: boolean;
    onToggleColumn: (id: StockControlColumnId) => void;
}

const StockControlToolBar = ({
    filterActive,
    onShowFilter,
    onReset,
    onRefresh,
    showCategory,
    showArticle,
    onToggleColumn,
}: StockControlToolBarProps) => {
    const { t } = useTranslation(['Warehouses', 'common']);

    return (
        <div className="mb-3 warehouse-toolbar">
            <div className="page-toolbar-actions warehouse-toolbar-actions">
                <ListToolBarActions
                    filters={
                        <EToolTip title={t('filter.title')}>
                            <span className="d-inline-block">
                                <Button
                                    className="fs-14 px-2"
                                    size="sm"
                                    variant={filterActive ? 'danger' : 'primary'}
                                    onClick={(e) => {
                                        e.currentTarget.blur();
                                        onShowFilter();
                                    }}
                                >
                                    <SolarIcon name="funnel" className="fs-14 p-0" />
                                </Button>
                            </span>
                        </EToolTip>
                    }
                    onReset={onReset}
                    onRefresh={onRefresh}
                    columns={{
                        items: [
                            { id: 'category', label: t('fields.category'), visible: showCategory },
                            { id: 'article', label: t('fields.article'), visible: showArticle },
                        ],
                        onToggle: (id) => onToggleColumn(id as StockControlColumnId),
                    }}
                />
            </div>
        </div>
    );
};

export default StockControlToolBar;
